module.exports = __webpack_public_path__ + "assets/img/approve-thumb.0dcb043d.svg";